/**
 * Redirect the user to a new url
 *
 * @param { Object } res: the server response (if server side).
 * @param { String } target: the url we want the user to be redirected to.
 */
export const redirect = (res, target) => {
  if (res) {
    // server
    // 303: "See other"
    res.writeHead(303, { Location: target })
    res.end()
  } else {
    // In the browser, we just pretend like this never even happened ;)
    window.location.replace(target)
  }
}
